import CliqConnectInstrunctionModal from './cliqconnect_instruction_modal';

export default CliqConnectInstrunctionModal;
